import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN REKOM ADMIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/MainRekomAdmin.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'admin-home',
          component: () => import('./views/admin/dashboard/Dashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/users',
          name: 'admin-users',
          component: () => import('./views/admin/users/UserList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/whistleblower',
          name: 'admin-whistleblower',
          component: () => import('./views/admin/whistleblower/Whistleblower.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users/register',
          name: 'admin-register-user',
          component: () => import('./views/admin/users/RegisterUser.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users/:userId',
          name: 'admin-user',
          component: () => import('./views/admin/users/user/User.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/venues',
          name: 'admin-venues',
          component: () => import('./views/admin/venues/VenueList.vue'),
          meta: {
            requiresAuth: true
          }
        },/*
        {
          path: '/venues/register',
          name: 'admin-register-venue',
          component: () => import('./views/admin/venues/RegisterVenue.vue'),
          meta: { 
            requiresAuth: true
          }
        },*/
        {
          path: '/venues/sync',
          name: 'admin-sync-planday-venues',
          component: () => import('./views/admin/venues/SyncPlandayVenues.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/content',
          name: 'admin-content',
          component: () => import('./views/admin/content/Content.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/content/:articleCategoryId',
          name: 'admin-content-article-category',
          component: () => import('./views/admin/content/Content.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/content/:articleCategoryId/:articleId',
          name: 'admin-content-article',
          component: () => import('./views/admin/content/Article.vue'),
          meta: {
            requiresAuth: true
          }
        },
        //admin-content-article
        {
          path: '/role-management',
          name: 'role-management',
          component: () => import('./views/admin/rolemanagement/RolesMenu.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/role-management/role/:roleId',
          name: 'admin-role-0',
          component: () => import('./views/admin/rolemanagement/Role/Role.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/surveys',
          name: 'admin-surveys',
          component: () => import('./views/admin/surveys/SurveyCategories.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/new-survey',
          name: 'admin-add-new-survey',
          component: () => import('./views/admin/surveys/AddNewTypedSurvey.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/survey/:surveyId',
          name: 'admin-survey-0',
          component: () => import('./views/admin/surveys/survey/Survey.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/quiz/:surveyId',
          name: 'admin-survey-1',
          component: () => import('./views/admin/surveys/quiz/Quiz.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/checklist/:surveyId',
          name: 'admin-survey-2',
          component: () => import('./views/admin/surveys/checklist/Checklist.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/venue-visit/:surveyId',
          name: 'admin-survey-3',
          component: () => import('./views/admin/surveys/venue-visit/VenueVisit.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/online-training/:surveyId',
          name: 'admin-survey-4',
          component: () => import('./views/admin/surveys/online-training/OnlineTraining.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/online-training/:surveyId/new-module',
          name: 'admin-survey-add-new-online-training-module',
          component: () => import('./views/admin/surveys/online-training/module/AddNewModule.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/online-training/:surveyId/:moduleId',
          name: 'admin-survey-online-training-module',
          component: () => import('./views/admin/surveys/online-training/module/Module.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/online-training/:surveyId/:moduleId/new-lesson',
          name: 'admin-survey-add-new-online-training-lesson',
          component: () => import('./views/admin/surveys/online-training/module/lesson/AddNewLesson.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/online-training/:surveyId/:moduleId/:lessonId',
          name: 'admin-survey-online-training-lesson',
          component: () => import('./views/admin/surveys/online-training/module/lesson/Lesson.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/surveys/:surveyType/:surveyId/:moduleId/:lessonId/:questionId',
          name: 'admin-survey-question',
          component: () => import('./views/admin/surveys/components/question/Question.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/venue-training',
          name: 'admin-venue-trainings',
          component: () => import('./views/admin/venue-training/VenueTrainingList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/venue-training/new-venue-training',
          name: 'admin-add-new-venue-training',
          component: () => import('./views/admin/venue-training/venue-training/AddNewVenueTraining.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/venue-training/:venueTrainingId',
          name: 'admin-venue-training',
          component: () => import('./views/admin/venue-training/venue-training/VenueTraining.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/calendar',
          name: 'admin-calendar',
          component: () => import('./views/admin/calendar/Calendar.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/planday',
          name: 'admin-planday',
          component: () => import('./views/admin/planday/PlandayPortalList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/planday/:portalId',
          name: 'admin-planday-portal',
          component: () => import('./views/admin/planday/portal/Portal.vue'),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/wall',
          name: 'admin-wall',
          component: () => import('./views/admin/news/NewsItemList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/wall/:wallPostId',
          name: 'admin-wall-post',
          component: () => import('./views/admin/news/NewsItem.vue'),
          meta: {
            requiresAuth: true
          }
        },
      ],
    },


    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/auth-redirect',
          name: 'auth-redirect',
          component: () => import('@/views/pages/AuthRedirect.vue')
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/AutoLogin.vue')
        },
        {
          path: '/venue/stripe-connect/redirect',
          component: () => import('./views/pages/PaymentAccountConnected.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: "/pages/no-access",
          name: "page-no-access",
          component: () => import("@/views/pages/NoAccess.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.beforeEach((to, from, next) => {

  if (!store.getters.hasFetchedPermissions) {
    return;
  }

  // No auth required
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next();
    return;
  }

  // if not logged in, wait for login
  if (!localStorage.getItem("rekom.life.accessToken")) {
    return;
  }

  // If no access to any pages, redirect to no access page
  if (store.getters.hasFetchedPermissions && !store.getters["services/firstServiceWithSidebarItems"]) {
    next({ name: 'page-no-access' })
    return;
  }


  // If on frontpage redirect to first availaible page
  if (to.path === "/") {
    var item = store.getters["services/firstServiceWithSidebarItems"];
    if (item) {
      next({ path: item.url })
      return;
    }
    return;
  }

  // Authenticated and heading to specific page
  const requiresIdamAuth = to.matched.some(record => record.meta.permission)
  const hasIdamPermission = !requiresIdamAuth || Vue.prototype.hasPermission(to.meta.permission)
  if (hasIdamPermission) {
    next();
    return;
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
